import React, { useState, useEffect, useCallback, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Button,
  CircularProgress,
  NativeSelect,
  IconButton,
  Tooltip,
  ButtonGroup,
} from "@material-ui/core";
import useReactRouter from "use-react-router";
import { getuserbyid } from "../../../API/Auth";
import { LangContext } from "../../../Context/Langcontext";
import { createUserbyAdmin, updateUser } from "../../../API/User";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { UserContext } from "../../../Context/UserContext";
import { useSnackbar } from "notistack";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "99.5%",
    minHeight: "-webkit-fill-available",
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    // minHeight: "100%",
    // maxHeight: "auto",
    minHeight: "-webkit-fill-available",
    maxHeight: "100%",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    marginLeft: "1rem",
    "&:hover": {
      background: "#e16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  cancel: {
    borderRadius: 8,
    padding: "0.5rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#BFC0BF",
    color: "#595A5A",
    marginLeft: "1rem",
    "&:hover": {
      background: "#BFC0BF",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  textfield: {
    "& .MuiInputBase-input": {
      height: "1.5rem",
    },
  },
  input: {
    fontSize: "1.2rem",
    fontWeight: 200,
    color: "#595A5A",
  },
  label: {
    fontWeight: 400,
    color: "#595A5A",
    fontSize: "1rem",
  },
  select: {
    fontSize: "1.2rem",
    fontWeight: 200,
    color: "#595A5A",
  },
  optiontext: {
    fontSize: "1.2rem",
    fontWeight: 200,
    color: "#595A5A",
  },
  btndis: {
    borderRadius: 8,
    padding: "0.5rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#ebebeb",
    color: "#FFFFFF",
    marginLeft: "1rem",
  },
  iconbtn: {
    padding: 6,
  },
  activebtn: {
    padding: "0.5rem 4rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#595a5a",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#595a5a",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  nonactive: {
    padding: "0.5rem 4rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#9b9b9b",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#9b9b9b",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  btngroup: {
    "& .MuiButtonGroup-groupedContainedHorizontal:not(:last-child)": {
      borderRight: "unset",
    },
  },
}));
const Createuser = ({ create, setCreate }) => {
  const classes = useStyle();
  const { history, match } = useReactRouter();
  const [fetch, setfetch] = useState(false);
  const langContext = useContext(LangContext);
  const [disable, setdisable] = useState(true);
  const [loading, setloading] = useState(false);
  const userContext = useContext(UserContext);
  const userInfo = userContext.state;
  const [focusIcon, setFocusIcon] = useState({
    showPassword: false,
  });
  const { enqueueSnackbar } = useSnackbar();

  const rolelist = [
    { title: "Contract User", value: "contract", disabled: false },
    // {
    //   title: "Contract User Designer",
    //   value: "contract_user_designer",
    //   disabled: false,
    // },
    // { title: "Officer Creator", value: "officer_creator", disabled: false },
    { title: "Officer User", value: "officer", disabled: false },
    { title: "Public User", value: "public", disabled: false },
  ];
  const lang = langContext.lang.data;
  const [state, setstate] = useState({
    start: "",
    end: "",
    role: "contract",
    password: "",
    billing_info: {},
  });
  const [form, setForm] = useState([]);

  const onChange = (e, index) => {
    const formvalue = [...form];
    formvalue[index].value = e.target.value;
    setForm(formvalue);
    if (formvalue[index].value !== e.target.value) {
      setdisable(true);
    } else {
      setdisable(false);
    }
  };

  const setData = useCallback(async () => {
    if (match.params.id !== "add") {
      const user = await getuserbyid(match.params.id);
      if (user.status.code === 200) {
        setForm([
          {
            name: "name",
            title: lang.Name,
            value: user.data[0].first_name,
            secure: true,
            type: "text",
          },
          {
            name: "lastname",
            title: lang.Lastname,
            value: user.data[0].last_name,
            secure: true,
            type: "text",
          },
          {
            name: "phone",
            title: lang.Phone,
            value: user.data[0].phone,
            secure: false,
            type: "text",
          },
          {
            name: "organization",
            title: lang.Organization,
            value: user.data[0].organization,
            secure: true,
            type: "text",
          },
          {
            name: "address",
            title: lang.Address,
            value: user.data[0].address,
            secure: false,
            type: "text",
          },
          {
            name: "district",
            title: lang.District,
            value: user.data[0].amphoe,
            secure: false,
            type: "text",
          },
          {
            name: "subdistrict",
            title: lang.Subdistrict,
            value: user.data[0].tambon,
            secure: false,
            type: "text",
          },
          {
            name: "city",
            title: lang.City,
            value: user.data[0].province,
            secure: false,
            type: "text",
          },
          {
            name: "country",
            title: lang.Country,
            value: user.data[0].country,
            secure: false,
            type: "text",
          },
          {
            name: "zipcode",
            title: lang.Zipcode,
            value: user.data[0].zipcode,
            secure: false,
            type: "text",
          },
          {
            name: "email",
            title: lang.Email,
            value: user.data[0].email,
            secure: true,
            type: "email",
          },
        ]);

        // var d = new Date(user.data[0].created_at),
        //   month = "" + (d.getMonth() + 1),
        //   day = "" + d.getDate(),
        //   year = d.getFullYear();

        // if (month.length < 2) month = "0" + month;
        // if (day.length < 2) day = "0" + day;
        setstate({
          ...state,
          start:
            user.data[0].contract !== undefined
              ? user.data[0].contract.start_date
              : "",
          end:
            user.data[0].contract !== undefined
              ? user.data[0].contract.end_date
              : "",
          role: user.data[0].role,
          billing_info:
            user.data[0].billing_info !== undefined
              ? user.data[0].billing_info
              : {},
        });
      } else {
      }
    } else {
      setForm([
        {
          name: "name",
          title: lang.Name,
          value: "",
          secure: true,
          type: "text",
        },
        {
          name: "lastname",
          title: lang.Lastname,
          value: "",
          secure: true,
          type: "text",
        },
        {
          name: "phone",
          title: lang.Phone,
          value: "",
          secure: false,
          type: "text",
        },
        {
          name: "organization",
          title: lang.Organization,
          value: "",
          secure: true,
          type: "text",
        },
        {
          name: "address",
          title: lang.Address,
          value: "",
          secure: false,
          type: "text",
        },
        {
          name: "district",
          title: lang.District,
          value: "",
          secure: false,
          type: "text",
        },
        {
          name: "subdistrict",
          title: lang.Subdistrict,
          value: "",
          secure: false,
          type: "text",
        },
        {
          name: "city",
          title: lang.City,
          value: "",
          secure: false,
          type: "text",
        },
        {
          name: "country",
          title: lang.Country,
          value: "",
          secure: false,
          type: "text",
        },
        {
          name: "zipcode",
          title: lang.Zipcode,
          value: "",
          secure: false,
          type: "text",
        },
        {
          name: "email",
          title: lang.Email,
          value: "",
          secure: true,
          type: "email",
        },
      ]);

      var date = new Date(),
        m = "" + (date.getMonth() + 1),
        today = "" + date.getDate(),
        y = date.getFullYear();

      if (m.length < 2) m = "0" + m;
      if (today.length < 2) today = "0" + today;
      setstate({ ...state, start: [y, m, today].join("-") });
    }
  }, [match, lang, state]);

  useEffect(() => {
    if (!fetch) {
      setData();
      setfetch(true);
    }
  }, [setData, fetch]);

  const onUpdate = async (event) => {
    event.preventDefault();
    let con = {};
    if (state.start !== "") {
      con.start_date = state.start;
    }
    if (state.end !== "") {
      con.end_date = state.end;
    }
    let input = {};
    if (con.start_date === undefined && con.end_date === undefined) {
      input = {
        email: form[10].value,
        first_name: form[0].value,
        last_name: form[1].value,
        organization: form[3].value,
        address: form[4].value,
        tambon: form[6].value,
        amphoe: form[5].value,
        province: form[7].value,
        zipcode: form[9].value,
        country: form[8].value,
        phone: form[2].value,
        role: state.role,
        enabled: true,
        password: state.password,
        billing_info: state.billing_info,
      };
    } else {
      input = {
        email: form[10].value,
        first_name: form[0].value,
        last_name: form[1].value,
        organization: form[3].value,
        address: form[4].value,
        tambon: form[6].value,
        amphoe: form[5].value,
        province: form[7].value,
        zipcode: form[9].value,
        country: form[8].value,
        phone: form[2].value,
        role: state.role,
        enabled: true,
        password: state.password,
        billing_info: state.billing_info,
        contract: con,
      };
    }

    const update = await updateUser(match.params.id, input);
    if (update.status.code === 200) {
      setdisable(true);
      setloading(true);
      setTimeout(() => {
        let userdata = [...userContext.data];
        let index = userdata
          .map((rs) => {
            return rs._id;
          })
          .indexOf(match.params.id);
        input.created_at = update.data[0].created_at;
        input._id = match.params.id;
        userdata[index] = input;
        // userdata.push(update.data[0]);
        userContext.setData(userdata);

        enqueueSnackbar(lang.Updateusersuccess, {
          variant: "success",
        });
        setloading(false);
        history.replace("/app/useradmin");
      }, 2000);
    } else {
      enqueueSnackbar(update.status.message, {
        variant: "error",
      });
    }
  };
  const onCreate = async (event) => {
    event.preventDefault();
    let input = {
      email: form[10].value,
      first_name: form[0].value,
      last_name: form[1].value,
      organization: form[3].value,
      address: form[4].value,
      tambon: form[6].value,
      amphoe: form[5].value,
      province: form[7].value,
      zipcode: form[9].value,
      country: form[8].value,
      phone: form[2].value,
      role: state.role,
      enabled: true,
      password: state.password,
      billing_info: {},
      contract: { start_date: state.start, end_date: state.end },
    };

    const add = await createUserbyAdmin(input);
    if (add.status.code === 201) {
      setdisable(true);
      setloading(true);
      setTimeout(() => {
        let userdata = [...userContext.data];
        userdata.push(add.data[0]);
        userContext.setData(userdata);

        enqueueSnackbar(lang.Addusersuccess, {
          variant: "success",
        });
        setloading(false);
        history.replace("/app/useradmin");
      }, 2000);
    } else {
      enqueueSnackbar(add.status.message, {
        variant: "error",
      });
    }
  };

  return (
    <div className={classes.root}>
      <Card className={classes.cardapi}>
        {match.params.id === "add" ? null : (
          <div style={{ backgroundColor: "#f4f4f4", width: "100%" }}>
            <ButtonGroup variant="contained" className={classes.btngroup}>
              <Button
                onClick={() => {
                  history.push(`/app/useradmin/user/${match.params.id}-null`);
                }}
                className={
                  match.params.payment !== "null"
                    ? classes.nonactive
                    : classes.activebtn
                }
              >
                {lang.UserProfile}
              </Button>
              <Button
                onClick={() => {
                  history.push(`/app/useradmin/user/${match.params.id}-credit`);
                }}
                className={
                  match.params.payment === "null"
                    ? classes.nonactive
                    : classes.activebtn
                }
              >
                {lang.AddCredit}
              </Button>
            </ButtonGroup>
          </div>
        )}

        <div style={{ margin: "4rem" }}>
          <form onSubmit={match.params.id !== "add" ? onUpdate : onCreate}>
            <Grid container spacing={6}>
              {form.map((item, index) => {
                return (
                  <Grid item xs={6} key={item.title}>
                    <TextField
                      id={`text_${item.name}`}
                      required={item.secure}
                      label={item.title}
                      type={item.type}
                      name={item.name}
                      fullWidth
                      className={classes.textfield}
                      value={item.value}
                      onChange={(e) => {
                        onChange(e, index);
                      }}
                      inputProps={{
                        className: classes.input,
                      }}
                      InputLabelProps={{
                        className: classes.label,
                      }}
                    />
                  </Grid>
                );
              })}
              <Grid item xs={6}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel
                    id="demo-simple-select-outlined-label"
                    className={classes.label}
                  >
                    {lang.Type}
                  </InputLabel>
                  <NativeSelect
                    id="demo-customized-api"
                    className={classes.select}
                    value={state.role}
                    onChange={(e) => {
                      setstate({ ...state, role: e.target.value });
                      setdisable(false);
                    }}
                  >
                    {(userInfo.role === "admin" ||
                      userInfo.role === "root") && (
                      <option value={"admin"} className={classes.optiontext}>
                        Admin
                      </option>
                    )}
                    {rolelist.map((rs) => {
                      return (
                        <option
                          key={rs.value}
                          value={rs.value}
                          className={classes.optiontext}
                          disabled={rs.disabled}
                        >
                          {rs.title}
                        </option>
                      );
                    })}
                  </NativeSelect>
                </FormControl>
              </Grid>
              {match.params.id === "add" ? (
                <Grid item xs={6}>
                  <TextField
                    id="password"
                    required
                    label={lang.Password}
                    type={focusIcon.showPassword ? "text" : "password"}
                    name="password"
                    fullWidth
                    className={classes.textfield}
                    value={state.password}
                    onChange={(e) => {
                      setstate({ ...state, password: e.target.value });
                    }}
                    inputProps={{
                      className: classes.input,
                    }}
                    InputLabelProps={{
                      className: classes.label,
                    }}
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          className={classes.iconbtn}
                          aria-label="Toggle password visibility"
                          onClick={() => {
                            setFocusIcon({
                              ...focusIcon,
                              showPassword: !focusIcon.showPassword,
                            });
                          }}
                        >
                          {focusIcon.showPassword ? (
                            <MdVisibility />
                          ) : (
                            <MdVisibilityOff />
                          )}
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>
              ) : null}

              <Grid item xs={6}>
                <TextField
                  id="start"
                  required={match.params.id !== "add" ? false : true}
                  label={lang.Start}
                  type="date"
                  fullWidth
                  value={state.start}
                  onChange={(e) => {
                    setstate({ ...state, start: e.target.value });
                    setdisable(false);
                  }}
                  placeholder="Start"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.label,
                  }}
                  inputProps={{
                    className: classes.input,
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required={match.params.id !== "add" ? false : true}
                  fullWidth
                  id="end"
                  label={lang.End}
                  type="date"
                  value={state.end}
                  onChange={(e) => {
                    setstate({ ...state, end: e.target.value });
                    setdisable(false);
                  }}
                  placeholder="End"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.label,
                  }}
                  inputProps={{
                    className: classes.input,
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Tooltip title="คลิกเพื่อยกเลิก" placement="top">
                  <Button
                    className={classes.cancel}
                    onClick={() => {
                      history.push("/app/useradmin");
                    }}
                  >
                    {lang.Cancel}
                  </Button>
                </Tooltip>

                <Tooltip
                  title={
                    match.params.id !== "add"
                      ? "คลิกเพื่อแก้ไขผู้ใช้"
                      : "คลิกเพื่อเพิ่มผู้ใช้"
                  }
                  placement="top"
                >
                  <span>
                    <Button
                      type="submit"
                      disabled={disable}
                      className={disable ? classes.btndis : classes.btnstyle}
                      onClick={() => {
                        // history.replace("/app/useradmin");
                      }}
                      startIcon={
                        loading ? (
                          <CircularProgress
                            size={24}
                            style={{ marginRight: "0.5rem", color: "#b0b0b0" }}
                          />
                        ) : null
                      }
                    >
                      {match.params.id !== "add"
                        ? lang.Update
                        : lang.CreateUser}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            </Grid>
          </form>
        </div>
      </Card>
    </div>
  );
};

export default Createuser;
